export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 4_12.22f5299c.jpg";